/**
 * Labels of the GCC pipeline steps (matches GccProgressEvent.step). Shared so job
 * progress, the wizard and the Step 0/1 trace entries use the same names. Progress
 * and traces saved before WI 2323 keep the labels they were saved with.
 */
export const GCC_STEP_LABELS: Readonly<Record<0 | 1 | 2 | 3 | 4, string>> = {
  0: 'Current-State Baseline',
  1: 'AI Disposition & Residual Workload',
  2: 'Residual Sourcing: Ownership × Location',
  3: 'Pathways & Transformation/Migration Waves',
  4: 'Future Workforce & Value Case',
}
